import { useCallback } from "react";
import { useContext } from "react";
import { ActivitiesContext } from "../../context/activities-context";
import { CheckActivityType, CheckAgeCategory } from "./functions";
import TransparentActivityFilter from "./TransparentActivityFilter";
import TransparentAgeFilter from "./TransparentAgeFilter";
import TransparentLocationFilter from "./TransparentLocationFilter";
import TransparentSearchFilter from "./TransparentSearchFilter";

const TransparentFilter = () => {
	const {
		ageButtonId,
		setAgeString,
		activityButtonId,
		setActivityString,
		searchInputRef,
		locationButtonId,
		distanceButtonId,
		setLocationString,
		setDistanceString,
		setLocationQuery,
		setDistanceQuery,
		setSearchString,

		executeScroll,
		dictionaryWords,
		isLoadingDictionary,
	} = useContext(ActivitiesContext);

	const onSubmit = useCallback((event) => {
		event.preventDefault();
		executeScroll();

		setAgeString(CheckAgeCategory(ageButtonId));
		setActivityString(CheckActivityType(activityButtonId));
		
		if (locationButtonId === "all" || locationButtonId === "") {
			setLocationString("");
			setDistanceString("");
		} else {
			setLocationString(`AND regions:"${locationButtonId}"`);
			
			setLocationQuery(`AND regions:"${locationButtonId}"`);
			setDistanceQuery(distanceButtonId);
		}

		setSearchString(searchInputRef.current.value);
	}, [executeScroll, setAgeString, ageButtonId, setActivityString, activityButtonId, searchInputRef, setLocationString, setDistanceString, setSearchString, locationButtonId]);

	return (
		<div className="c-transparent">
			<div className=" c-section-wrap c-section-index full-width">
				<div className="c-section c-section--filter c-section-transparent">
					<div className="c-section__body">
						<form className="c-form" onSubmit={onSubmit}>
							<fieldset className="c-fieldset">
								{/* <div className="c-fieldset__header col-12">
									{!isLoadingDictionary &&
										<legend>
											{dictionaryWords.iSeek}
										</legend>
									}
								</div> */}
								{!isLoadingDictionary && 
									<div className="c-transparent-filter__container">
										<TransparentSearchFilter />
										<TransparentActivityFilter />
										<TransparentAgeFilter />
										<TransparentLocationFilter />
										<div className="c-transparent-filter__button__container">
											<button
												href="#resultaten"
												className="c-button c-transparent-filter__button"
												type="submit"
											>
												{dictionaryWords.search}
											</button>
										</div>
									</div>
								}
							</fieldset>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TransparentFilter;
